export interface FlagType {
  id: number;
  name: string;
  color: string;
  active: boolean;
}

export interface FlagStatus {
  id: number;
  active: boolean;
}


export const FlagTypes: FlagType[] = [
  {
    id: 1,
    name: 'Żółta',
    color: '#FFD702',
    active: true,
  },
  {
    id: 2,
    name: 'Pomarańczowa',
    color: '#FF9A02',
    active: true,
  },
  {
    id: 3,
    name: 'Czerwona',
    color: '#BC0000',
    active: true,
  },
  {
    id: 4,
    name: 'Różowa',
    color: '#EA2075',
    active: true,
  },
  {
    id: 5,
    name: 'Fioletowa',
    color: '#3C419A',
    active: true,
  },
  {
    id: 6,
    name: 'Niebieska',
    color: '#4FA7EE',
    active: true,
  },
  {
    id: 7,
    name: 'Granatowa',
    color: '#3560FF',
    active: true,
  },
  {
    id: 8,
    name: 'Zielona',
    color: '#347F42',
    active: true,
  },
  {
    id: 9,
    name: 'Brązowa',
    color: '#865C1D',
    active: true,
  },
  {
    id: 10,
    name: 'Szara',
    color: '#6F707B',
    active: true,
  },
];

export interface FlagsDto {
  flagId: string;
  flagDefinitionId: number;
  comment?: string;
  isDeleted?: boolean;
}
